import { registerSW } from "virtual:pwa-register";
import {
  publishPwaUpdate,
} from "./events";
import { shouldRegisterPwa } from "./support";

export function registerPwa(): void {
  if (!shouldRegisterPwa(import.meta.env.PROD, navigator)) {
    return;
  }

  const applyUpdate = registerSW({
    immediate: true,
    onNeedRefresh() {
      publishPwaUpdate({
        applyUpdate: () => applyUpdate(true),
      });
    },
    onRegisterError() {
      // The web app remains fully usable when registration is blocked or fails.
    },
  });
}
